import { useEffect, useRef } from 'react';
import {
    cart,
    favourite,
    notification,
    order,
    profile,
    setting,
    activeCart,
    activeFavourite,
    activeNotification,
    activeOrder,
    activeProfile,
    activeSetting,
    review,
    activeReview,
    logout,
} from '../../assets/svgs';
import Typography from '../Typography/Typography';
import styles from './style.module.css';
import { NavLink, useLocation } from 'react-router-dom';

interface burgerProp {
    open?: boolean
    toggle: () => void
}

export const BurgerMenu: React.FC<burgerProp> = ({
    open,
    toggle
}) => {

    const location = useLocation()
    const sidebarRef = useRef<HTMLDivElement>(null);

    // Detect outside click
    // useEffect(() => {
    //     const handleClickOutside = (event: MouseEvent) => {
    //         if (sidebarRef.current && !sidebarRef.current.contains(event.target as Node)) {
    //             toggle();
    //         }
    //     }

    //     if (open) {
    //         document.addEventListener('mousedown', handleClickOutside);
    //     } else {
    //         document.removeEventListener('mousedown', handleClickOutside);
    //     }

    //     return () => {
    //         document.removeEventListener('mousedown', handleClickOutside);
    //     };
    // }, [open, toggle]);

    const items = [
        { label: 'Profile', href: '/buyer-profile', icon: profile, activeIcon: activeProfile, extraActive: [] },
        { label: 'Notifications', href: '/buyer-notification', icon: notification, activeIcon: activeNotification, extraActive: [] },
        { label: 'Cart', href: '/buyer-cart', icon: cart, activeIcon: activeCart, extraActive: ['/buyer-checkout'] },
        { label: 'My Orders', href: '/buyer-orders', icon: order, activeIcon: activeOrder, extraActive: ['/buyer-order'] },
        { label: 'Favourite', href: '/buyer-favourite', icon: favourite, activeIcon: activeFavourite, extraActive: [] },
        { label: 'Review', href: '/buyer-review', icon: review, activeIcon: activeReview, extraActive: ['/buyer-rate'] },
        { label: 'Settings', href: '/buyer-settings', icon: setting, activeIcon: activeSetting, extraActive: [] },
    ];

    if (!open) {
        return null
    }

    return (
        <div className={styles.overlay} onClick={toggle}>
            <aside
                ref={sidebarRef}
                onClick={(e) => e.stopPropagation()}
                className={styles.sidebar}
            >
                <nav className={styles.sidebarNav}>

                    {items.map((item) => {
                        const isActive =
                            location.pathname === item.href ||
                            item.extraActive.some((path) => location.pathname.startsWith(path));

                        return (
                            <NavLink key={item.href} to={item.href} onClick={toggle} className={styles.sidebarLink}>
                                <>
                                    <img src={isActive ? item.activeIcon : item.icon} alt={item.label} />
                                    <span className={`${styles.sidebarText} ${isActive ? styles.sidebarTextActive : ''}`}>
                                        {item.label}
                                    </span>
                                </>
                            </NavLink>
                        );
                    })}

                    <hr className={styles.line} />

                    <div className={styles.logoutCont}>
                        <img src={logout} alt="" />

                        <Typography
                            variant='heading5'
                        >
                            Log Out
                        </Typography>
                    </div>

                </nav>
            </aside>
        </div>
    );
};
